import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Loader from 'components/Loader'
import List from 'components/List'
import ListItem from 'components/List/ListItem'
import Pagination from 'components/Pagination'
import { shapePaginator } from 'resources/typeDefs'

import { getCurrentPaginationPage } from 'store/AppState/selector'
import { setCurrentPaginationPage } from 'store/AppState/actions'

const Printers = ({ isLoadingDevices, paginator }) => {
  const headers = ['Name', 'Type/Model', 'Connection', 'IP', 'Receipt Printer', 'Print Controller']
  const history = useHistory()

  const currentPaginationPage = useSelector((state) => getCurrentPaginationPage(state, 'printers'))
  const handlePersistPaginationPage = (page) => {
    setCurrentPaginationPage({ screen: 'printers', page })
  }

  if (isLoadingDevices) {
    return <Loader />
  }

  return (
    <div className="devices-list">
      <List headerItems={headers}>
        {paginator?.result?.map(
          ({ uuid, name, printerType, connection, configuration, port, receiptPrinter }) => {
            const connectionContent = connection === 'TCP' ? 'IP' : connection
            return (
              <div className="item" key={uuid}>
                <div
                  className="row"
                  onClick={() => {
                    history.push(`printers/${uuid}/edit`)
                  }}
                >
                  <div className="item-info-wrapper">
                    <span className="name">
                      <ListItem content={name} />
                    </span>
                  </div>
                  <div className="item-info-wrapper">
                    <ListItem content={printerType} />
                  </div>
                  <div className="item-info-wrapper">
                    <ListItem content={connectionContent} />
                  </div>
                  <div className="item-info-wrapper">
                    <ListItem content={port} />
                  </div>
                  <div className="item-info-wrapper">
                    <ListItem content={receiptPrinter ? 'Yes' : 'No'} />
                  </div>
                  <div className="item-info-wrapper">
                    <ListItem content={configuration?.name} />
                  </div>
                </div>
              </div>
            )
          },
        )}
      </List>
      <section className="footer-pagination">
        <Pagination
          currentPersistedPaginationPage={currentPaginationPage}
          handlePersistPaginationPage={handlePersistPaginationPage}
          paginator={paginator}
        />
      </section>
    </div>
  )
}

Printers.defaultProps = {
  emptyStateTitle: 'No items found!',
  emptySearchResultMessage: 'There are no items matching given search query.',
  emptySearchResultTitle: "We couldn't find what you were looking for",
  isFilteringItems: false,
}

Printers.propTypes = {
  paginator: shapePaginator,
  isLoadingDevices: PropTypes.bool.isRequired,
}

export default Printers
